import Request from "@services/request";
import { IGetAllFormData, IGetSingleFormData } from "./types";

const GetAll = async ({ query, page }: IGetAllFormData) =>
    await new Request().get<IReturnValue<Array<IArticles["get"]>>>("ARTICLES", {
        params: {
            query,
            page,
        },
    });

const GetSingle = async ({ id }: IGetSingleFormData) =>
    await new Request().get<IReturnValue<IArticle["get"]>>({
        base: "ARTICLE",
        params: {
            id,
        },
    });

const Create = async ({
    title,
    brief,
    body,
    url,
    tags,
    seoDescription,
    seoKeywords,
}: IArticles["post"]) =>
    await new Request().post<IArticles["post"], IReturnValue<any>>("ARTICLES", {
        title,
        brief,
        body,
        url,
        tags,
        seoDescription,
        seoKeywords,
    });

const Edit = async ({
    id,
    title,
    brief,
    body,
    url,
    tags,
    seoDescription,
    seoKeywords,
}: IArticle["put"]) =>
    await new Request().put<Omit<IArticle["put"], "id">, IReturnValue<any>>(
        {
            base: "ARTICLE",
            params: {
                id,
            },
        },
        {
            title,
            brief,
            body,
            url,
            tags,
            seoDescription,
            seoKeywords,
        },
    );

const Delete = async ({ id }: IArticle["delete"]) =>
    await new Request().delete<IReturnValue<any>>({
        base: "ARTICLE",
        params: {
            id,
        },
    });

const UploadStatic = async ({ id, file }: { id: number; file: File }) => {
    const formData = new FormData();

    formData.append("image", file);

    return await new Request().post<FormData, IReturnValue<string>>(
        {
            base: "ARTICLE_STATIC",
            params: { id },
        },
        formData,
    );
};

const DeleteBanner = async ({ id }: IArticle["delete"]) =>
    await new Request().delete<IReturnValue<any>>({
        base: "ARTICLE_BANNER",
        params: {
            id,
        },
    });

const DeleteThumbnail = async ({ id }: IArticle["delete"]) =>
    await new Request().delete<IReturnValue<any>>({
        base: "ARTICLE_THUMBNAIL",
        params: {
            id,
        },
    });

const Publish = async ({ id }: IArticle["delete"]) =>
    await new Request().post<{}, IReturnValue<any>>(
        {
            base: "ARTICLE_PUBLISH",
            params: {
                id,
            },
        },
        {},
    );

// Main Object
const ArticlesApis = {
    GetAll,
    GetSingle,
    Create,
    Edit,
    Delete,
    UploadStatic,
    DeleteBanner,
    DeleteThumbnail,
    Publish,
};

export default ArticlesApis;
